import { useEffect, useState } from "react";

const Table = ({ selectedYear, setYears, t, formatDate }) => {
  const [concerts, setConcerts] = useState([]);

  useEffect(() => {
    const fetchAvailableYears = async () => {
      try {
        const context = require.context(
          "../../data/concerts/",
          false,
          /\.json$/
        );
        const years = context
          .keys()
          .map((filename) => filename.match(/(\d+)\.json$/)[1]);
        setYears(years.sort((a, b) => b - a)); // Sort in descending order
      } catch (error) {
        console.error("Error fetching available years:", error);
      }
    };

    fetchAvailableYears();
  }, [setYears]);

  useEffect(() => {
    const loadConcerts = async () => {
      try {
        const response = await import(
          `../../data/concerts/${selectedYear}.json`
        );
        const allConcerts = response.default;

        const now = new Date();
        const expiredConcerts = allConcerts.filter((concert) => {
          const concertDate = new Date(concert.date);
          return concertDate < now;
        });

        setConcerts(expiredConcerts);
      } catch (error) {
        console.error(
          `Error loading concerts for year ${selectedYear}:`,
          error
        );
      }
    };

    loadConcerts();
  }, [selectedYear]);

  // Group concerts by season
  const groupedConcerts = concerts.reduce((acc, concert) => {
    const { season } = concert;
    if (!acc[season]) {
      acc[season] = [];
    }
    acc[season].push(concert);
    return acc;
  }, {});

  const getTitle = (season) => {
    switch (season) {
      case "fest_beeth":
        return t("archive.fest_beeth");
      case "mmi":
        return t("archive.mmi");
      case "open_reh":
        return t("archive.open_reh");
      case "event":
        return t("archive.event");
      case "fest_lavoro":
        return t("archive.fest_lavoro");
      case "mus_rac":
        return t("archive.mus_rac");
      case "scuola_55":
        return t("archive.scuola_55");
      default:
        return season;
    }
  };

  return (
    <div className="archive-table-container mt-4">
      {Object.keys(groupedConcerts).length > 0 ? (
        Object.keys(groupedConcerts).map((season) => (
          <div key={season} className="card border-0 shadow-sm rounded-4 p-4 mb-4 bg-white">
            <h4 className="section-subheading mb-4 pb-2 border-bottom">
              {getTitle(season)}
            </h4>
            <div className="table-responsive">
              <table className="table table-hover align-middle mb-0">
                <thead className="table-light">
                  <tr>
                    <th scope="col" style={{ minWidth: "160px" }}>
                      {t("archive.date_time_place")}
                    </th>
                    <th scope="col">{t("archive.title")}</th>
                    <th scope="col">{t("archive.artists")}</th>
                  </tr>
                </thead>
                <tbody>
                  {groupedConcerts[season].map((concert) => (
                    <tr key={concert.id}>
                      <td className="narrow">
                        <strong className="text-dark">
                          {formatDate(concert.date)}
                        </strong>
                        {concert.time && (
                          <div className="text-muted small">h {concert.time}</div>
                        )}
                        <small className="text-muted d-block">{concert.place}</small>
                      </td>
                      <td className="text-capitalize fw-semibold text-dark">
                        {concert.title}
                      </td>
                      <td className="text-muted small">
                        {concert.artists
                          .map((artist) => {
                            if (artist.name === "orchestra_busoni") {
                              return t(`concerts.${artist.name}`);
                            } else {
                              return artist.name;
                            }
                          })
                          .join(", ")}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ))
      ) : (
        <div className="text-center py-5 bg-white rounded-4 border shadow-sm">
          <p className="text-muted mb-0 fs-5">{t("archive.no_expired_concerts")}</p>
        </div>
      )}
    </div>
  );
};

export default Table;
